/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, September 2022
 *
 *****************************************************************************/

/**
 * This is a constant font-size file, all the font-size used in webapp are rest here
 */
export const FONT_SIZE = {
  FONT_SIZE_FOUR: "0.4rem",
  FONT_SIZE_SIX: "0.6rem",
  FONT_SIZE_EIGHT: "0.8rem",
  FONT_SIZE_TEN: "1rem",
  FONT_SIZE_TWELVE: "1.2rem",
  FONT_SIZE_FOURTEEN: "1.4rem",
  FONT_SIZE_SIXTEEN: "1.6rem",
  FONT_SIZE_EIGHTEEN: "1.8rem",
  FONT_SIZE_TWENTY: "2rem",
  FONT_SIZE_TWENTY_TWO: "2.2rem",
  FONT_SIZE_TWENTY_FOUR: "2.4rem",
  FONT_SIZE_TWENTY_SIX: "2.6rem",
  FONT_SIZE_TWENTY_EIGHT: "2.8rem",
  FONT_SIZE_THIRTY: "3rem",
  FONT_SIZE_THIRTY_TWO: "3.2rem",
  FONT_SIZE_THIRTY_FOUR: "3.4rem",
  FONT_SIZE_THIRTY_SIX: "3.6rem",
  FONT_SIZE_THIRTY_EIGHT: "3.8rem",
  FONT_SIZE_FORTY: "4rem",
  FONT_SIZE_FORTY_TWO: "4.2rem",
  FONT_SIZE_FORTY_FOUR: "4.4rem",
  FONT_SIZE_FORTY_SIX: "4.6rem",
  FONT_SIZE_FORTY_EIGHT: "4.8rem",
  FONT_SIZE_FIFTY: "5rem",
  FONT_SIZE_FIFTY_TWO: "5.2rem",
  FONT_SIZE_FIFTY_FOUR: "5.4rem",
  FONT_SIZE_FIFTY_SIX: "5.6rem",
  FONT_SIZE_FIFTY_EIGHT: "5.8rem",
  FONT_SIZE_SIXTY: "6rem",
};
